"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentImportUploadComponent = void 0;
const core_1 = require("@angular/core");
const helmFile_1 = require("./helmFile");
let AdjustmentImportUploadComponent = class AdjustmentImportUploadComponent {
    constructor() {
        this.filePath = '';
        this.filePathTrunc = '';
        this.fileInBuffer = false;
        this.file = new helmFile_1.HelmFile();
    }
    filePathChange($event) {
        this.file.dataEvent = $event;
        this.file.path = this.filePath;
        if (this.file.path) {
            this.fileInBuffer = true;
        }
        else {
            this.fileInBuffer = false;
        }
        try {
            this.filePathTrunc = this.filePath.split('fakepath\\')[1];
        }
        catch (err) {
            this.filePathTrunc = this.filePath;
        }
        ;
    }
    submit() {
        this.file.upload();
    }
};
exports.AdjustmentImportUploadComponent = AdjustmentImportUploadComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentImportUploadComponent.prototype, "date", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentImportUploadComponent.prototype, "selectedDsp", void 0);
exports.AdjustmentImportUploadComponent = AdjustmentImportUploadComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-import-upload',
        templateUrl: 'app/adjustment-import-upload.component.html',
        styleUrls: ['styles/adjustment.component.css']
    })
], AdjustmentImportUploadComponent);
//# sourceMappingURL=adjustment-import-upload.component.js.map